import { useQuery } from '@tanstack/react-query';
import { hyperlinkApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Hyperlinks attached to a job. */
export function useJobHyperlinks(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.jobs.hyperlinks(jobId ?? -1),
    queryFn: ({ signal }) =>
      hyperlinkApiClient.listHyperlinks(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 30_000,
    meta: { errorContext: 'job hyperlinks' },
  });
}
